/**
 * Canonical shared constants — mirrored from:
 *   shared/src/askwingo_shared/config/constants.py
 *
 * Keep in sync when updating the Python source.
 */

// ---------------------------------------------------------------------------
// File Upload Constraints
// ---------------------------------------------------------------------------

export const MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024; // 100 MB

export const ALLOWED_MIME_TYPES = [
  // Documents
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  // Spreadsheets
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv',
  // Presentations
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  // Images (scanned docs, receipts)
  'image/png',
  'image/jpeg',
  'image/tiff',
  'image/webp',
  'image/heic',
  // Text
  'text/plain',
  // Email
  'message/rfc822',
  'application/vnd.ms-outlook',
] as const;

export type AllowedMimeType = (typeof ALLOWED_MIME_TYPES)[number];
